import {
  type Context,
  createContext,
  type Dispatch,
  type MutableRefObject,
} from 'react';

import { PanelsState, PanelsReducerActions } from '../types/panels-state.js';
import { PanelSizes } from '../types/shared-panel-types.js';

export interface PanelsContextProps {
  state: PanelsState;
  panelSizes?: MutableRefObject<PanelSizes>;
  dispatch: Dispatch<PanelsReducerActions>;
  generateResizeEventHandlers: (handleOrder: number) => {
    onDragStart: () => void;
    onDrag: (deltaX: number) => void;
    onDragEnd: () => void;
    onKeyDown: (deltaX: number) => void;
  };
  disableAnimations: boolean;
}

/**
 * The PanelsContext holds all the information needed for managing the state of
 * a group of panels and add the event listeners for resizing to the resize handles.
 */
export const PanelsContext: Context<PanelsContextProps> =
  createContext<PanelsContextProps>({
    state: { panels: {}, resizeHandles: {} },
    dispatch: () => null,
    generateResizeEventHandlers: () => ({
      onDragStart: () => null,
      onDrag: () => null,
      onDragEnd: () => null,
      onKeyDown: () => null,
    }),
    disableAnimations: false,
  });
PanelsContext.displayName = 'PanelsContext';
